"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.IconContainer = exports.TableContainer = exports.SearchInput = exports.Search = exports.Header = void 0;
/**
 * Package import
 */
const styled_1 = __importDefault(require("@emotion/styled"));
/**
 * Style
 */
exports.Header = styled_1.default.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '5.5rem',
    p: {
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '1.25rem',
        lineHeight: '150%',
    }
});
exports.Search = styled_1.default.div({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
});
exports.SearchInput = styled_1.default.div({
    width: '18.5rem',
    marginRight: '1rem',
});
exports.TableContainer = styled_1.default.div({
    maxHeight: 'calc(100% - 5.5rem)',
    height: '100%',
});
exports.IconContainer = styled_1.default.div({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
});
exports.IconButton = styled_1.default.button({
    cursor: 'pointer',
});
